import Vue from 'vue'
import store from "../store/index"

// 注册一个全局自定义指令 `v-permission`
Vue.directive('permission', {
  // inserted：被绑定元素插入父节点时调用 (仅保证父节点存在，但不一定已被插入文档中)。
  inserted(el, binding, vnode) {
    console.log(el);
    const { value } = binding
    const all_permission = '*:*:*'
    const permissions = store.getters && store.getters.BtnPermissionData

    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value
      console.log(value);
      // all_permission === permission.code
      const hasPermissions = permissions.some((permission) => {
        return (
          all_permission === value[0] || permissionFlag.includes(permission.code)
        )
      })
      console.log(hasPermissions);
      if (!hasPermissions) {
        if(el){
          el.parentNode && el.parentNode.removeChild(el)
        }
        // 或者：el.style.display = 'none'
      }
    } else {
      throw new Error(`请设置操作权限标签值`)
    }
  }
})



// WEBPACK FOOTER //
// ./src/plugins/directive.js